import { useState, useRef } from 'react';
import STYLES from './StartButton.module.scss';

import startMenuButtonOpen from './images/menuOpen.png';
import startMenuButtonClosed from './images/menuClosed.png';

import StartMenu from './StartMenu';

const StartButton = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleStartMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <div className={STYLES.StartButton} ref={buttonRef}>
      <img
        onClick={() => setMenuOpen(!menuOpen)}
        className={STYLES.StartButton__image}
        src={menuOpen ? startMenuButtonOpen : startMenuButtonClosed}
        alt="Start Button"
      />
      {menuOpen && (
        <StartMenu handleClose={handleStartMenuClose} buttonRef={buttonRef} />
      )}
    </div>
  );
};

export default StartButton;
